/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of friend connection
 * @export
 */
export const FriendStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    BLOCKED: 'BLOCKED'
} as const;
export type FriendStatus = typeof FriendStatus[keyof typeof FriendStatus];


export function instanceOfFriendStatus(value: any): boolean {
    for (const key in FriendStatus) {
        if (Object.prototype.hasOwnProperty.call(FriendStatus, key)) {
            if (FriendStatus[key as keyof typeof FriendStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FriendStatusFromJSON(json: any): FriendStatus {
    return FriendStatusFromJSONTyped(json, false);
}

export function FriendStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FriendStatus {
    return json as FriendStatus;
}

export function FriendStatusToJSON(value?: FriendStatus | null): any {
    return value as any;
}

export function FriendStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FriendStatus {
    return value as FriendStatus;
}

